import React from "react";
import Image from "gatsby-image";

import {
  Container,
  ImageContainer,
} from "./Components";

const Gallery = ({ gallery }) => {
  return (
    <Container>
      {gallery.map(item => {
        return (
          <ImageContainer>
            <Image
              style={{ height: '100%' }}
              key={item.id}
              fluid={item.image.childImageSharp.fluid}
            />
          </ImageContainer>
        );
      })}
    </Container>
  );
};

export default Gallery;
